import { Dayjs } from 'dayjs';
import dayjs from './dayjsSetup';

const isStartOfYear = (date: Dayjs): boolean => {
  return dayjs(date).isSame(dayjs(date).startOf('year'), 'day');
};

export default isStartOfYear;
